import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cms-text-input',
  templateUrl: './cms-text-input.component.html',
  styleUrls: ['./cms-text-input.component.scss']
})
export class CmsTextInputComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/cms-module/components/cms-text-input/cms-text-input.component.ts